import React, { Component } from "react";
import PropTypes from "prop-types";
import { prettyDates, bucketUrl } from "../../../../../actions/utils";
import { Table, TableHead, TableRow, TableCell, TableBody, Button, Grid, Icon } from "@material-ui/core";
import "./AnnouncementList.css";
import { connect } from "react-redux";
import { toggleAnnouncement, loadLandlordAnnouncements, handleAnnouncementSelection } from "../../../../../actions/landlordActions";
import LinkHelper from "../../../../Helpers/Link";

const propertyImages = [
    require("../../../../../images/png/office1.jpg"),
    require("../../../../../images/png/office2.jpg"),
    require("../../../../../images/png/office3.jpg"),
    require("../../../../../images/png/office4.jpg"),
    require("../../../../../images/png/office5.jpg"),
    require("../../../../../images/png/office6.jpg"),
    require("../../../../../images/png/office7.jpg"),
    require("../../../../../images/png/office8.jpg")

]
class AnnouncementList extends Component {

    static propTypes = {
        announcements: PropTypes.array.isRequired,
        emptyText: PropTypes.node
    }

    constructor( props ) {
        super( props );
        this.announcementMap = this.announcementMap.bind( this );
    }

    componentDidMount() {
        this.props.loadAnnouncements();
    }

    announcementMap( anno ) {
        const props = anno.properties;
        const imageExists = ( anno.residence.files[0] && anno.residence.files[0].key );
        // const imageUrl = imageExists ? `${bucketUrl}/${anno.residence.files[0].key}` : "";
        const imageUrl = propertyImages[anno.id%propertyImages.length]
        return (
            anno ?
            <TableRow
                key={anno.id}
                className="MatchList-row AnnouncementList-row"
            >
                {/* <TableCell><img className="MatchList-row-preview" src={anno.residence.files[0] && anno.residence.files[0].key? `${bucketUrl}/${anno.residence.files[0].key}` : office} alt="Preview"/></TableCell> */}
                <TableCell>
                    <LinkHelper to={`/user/announcements/${anno.id}`} > {
                        imageUrl
                        ? <img className="MatchList-row-preview" src={imageUrl} alt="Preview"/>
                        : <Grid container justify="center" alignItems="center" className="MatchList-row-preview" style={{width:"90px",height:"90px"}}><Icon color="secondary">home</Icon></Grid>
                    } </LinkHelper>
                </TableCell>
                <TableCell style={{whiteSpace: 'pre-line'}}>{anno.properties.description ? anno.properties.description : `Nice ${props.rooms} rooms ${anno.residence.houseType}`}</TableCell>
                <TableCell>{anno.properties.address ? props.address : 'Address not specified'}</TableCell>
                <TableCell>{props.moveOutDate ? ( props.whenAvailable ? `${prettyDates.day(props.whenAvailable)} - ${prettyDates.day( props.moveOutDate )}` : `Until ${prettyDates.day( props.moveOutDate )}` ) : ( props.whenAvailable ? `${prettyDates.day( props.whenAvailable )} -` : "" )}</TableCell>
                <TableCell style={{borderBottomColor:"transparent"}}>
                    <Button
                        onClick={() => this.props.toggleAnnouncement( anno )}
                        variant="text"
                        color="primary"
                        size="medium"
                    >
                        <span className="AnnouncementList-hoveritem">
                            { anno.isActive ? "Make hidden" : "Make public" }
                        </span>
                    </Button>
                </TableCell>
            </TableRow> : <h1>Error</h1>
        );
    }

    render() {
        const { announcements, emptyText } = this.props;
        console.log( "ANNOUNCEMENTS >>", announcements ); // DEBUG

        if ( announcements.length === 0 ) {
            return <div>{emptyText}</div>
        }
        return (
            <Table>
                <colgroup>
                    <col width="10%"/>{/* Property */}
                    <col width="25%"/>{/* Description */}
                    <col width="25%"/>{/* Address */}
                    <col width="25%"/>{/* Rent period */}
                    <col width="5%"/>{/* Edit */}
                </colgroup>
                <TableHead>
                    <TableRow>
                        <TableCell style={{fontWeight: 'bold'}}>Property</TableCell>
                        <TableCell style={{fontWeight: 'bold'}}>Description</TableCell>
                        <TableCell style={{fontWeight: 'bold'}}>Address</TableCell>
                        <TableCell style={{fontWeight: 'bold'}}>Rent period</TableCell>
                        <TableCell style={{borderBottomColor:"transparent"}}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {announcements ? announcements.map( this.announcementMap ) : ""}
                </TableBody>
            </Table>
        );
    }

}

const mapDispatchToProps = dispatch => ({
    onSelect: ( id ) => dispatch( handleAnnouncementSelection( id ) ),
    toggleAnnouncement: ( anno ) => dispatch( toggleAnnouncement( anno ) ),
    loadAnnouncements: () => dispatch( loadLandlordAnnouncements() )
})

export default connect(
    state => ({}),
    mapDispatchToProps
)( AnnouncementList );